import type { BoxProps } from '@mui/material';
import { Box, CircularProgress } from '@mui/material';
import { circularProgressClasses } from '@mui/material/CircularProgress';

type PpCircularSpinner = Pick<BoxProps, 'sx'> & {
  size?: number;
};

export function CircularSpinner({ size = 32, sx }: PpCircularSpinner): React.ReactElement {
  return (
    <Box sx={{ ...sx, position: 'relative' }}>
      <CircularProgress
        size={size}
        sx={{
          color: (theme) => theme.palette.grayscale[300],
        }}
        thickness={4}
        value={100}
        variant="determinate"
      />
      <CircularProgress
        disableShrink
        color="secondary"
        size={size}
        sx={{
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
          animationDuration: '550ms',
          color: (theme) => theme.palette.grayscale[500],
          left: 0,
          position: 'absolute',
        }}
        thickness={4}
        variant="indeterminate"
      />
    </Box>
  );
}
